import { useEffect, useState } from "react";

/**
 * Liste gövdesinin gerçek yüksekliğinden sayfa başına satır sayısını hesaplar.
 * Liste her ekranda tam dolar, altında boşluk kalmaz; sabit yükseklik
 * matematiğine (viewport - sihirli sayı) gerek kalmaz.
 *
 * @param {React.RefObject<HTMLElement>} ref - ölçülecek gövde elemanı
 * @param {{rowHeight?: number, headerHeight?: number, minRows?: number}} options
 * @returns {number} sayfa başına satır sayısı
 */
export default function useAutoPageSize(ref, options = {}) {
  const { rowHeight = 56, headerHeight = 40, minRows = 5 } = options;
  const [pageSize, setPageSize] = useState(minRows);

  useEffect(() => {
    const el = ref?.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;

    const observer = new ResizeObserver((entries) => {
      const height = entries?.[0]?.contentRect?.height;
      if (!height || height <= 0) return;
      const usable = height - headerHeight;
      const next = Math.max(minRows, Math.floor(usable / rowHeight));
      setPageSize((prev) => (prev === next ? prev : next));
    });

    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, rowHeight, headerHeight, minRows]);

  return pageSize;
}
